import { api } from "@tt-app/api";
import {
  VUEX_LEARNING_HISTORY_ACTION_NAMES,
  VUEX_LEARNING_HISTORY_MUTATION_NAMES
} from "@tt-app/constants";
import { getAuthInfo } from "@tt-app/utils";

const {
  ACHIEVEMENT_REQUEST,
  ACTIVITY_SUMMARY_REQUEST,
  EXERCISE_LOGS_REQUEST,
  LEARNING_STATS_REQUEST,
  PERFORMANCE_SUMMARY_REQUEST,
  SEND_FEEDBACK,
  RECENT_EXERCISES_REQUEST
} = VUEX_LEARNING_HISTORY_ACTION_NAMES;

const {
  ACHIEVEMENT,
  ACTIVITY_SUMMARY,
  EXERCISE_LOGS,
  LEARNING_STATS,
  PERFORMANCE_SUMMARY,
  RECENT_EXERCISES,
  LOADING
} = VUEX_LEARNING_HISTORY_MUTATION_NAMES;

const historyActions = {
  async [ACHIEVEMENT_REQUEST]({ commit, rootGetters }: any, payload: any) {
    try {
      commit(ACHIEVEMENT, { learnedBadges: undefined, trophies: undefined });

      const authInfo = await getAuthInfo(rootGetters);
      const response = await api.learningHistory.achievement({ params: payload, authInfo });

      commit(ACHIEVEMENT, response.data);
    } catch (error) {
      console.log({ error });
    }
  },
  async [ACTIVITY_SUMMARY_REQUEST]({ commit, rootGetters }: any, payload: any) {
    try {
      commit(ACTIVITY_SUMMARY, undefined);

      const authInfo = await getAuthInfo(rootGetters);
      const response = await api.learningHistory.activitySummary({ params: payload, authInfo });

      commit(ACTIVITY_SUMMARY, response.data);
    } catch (error) {
      console.log({ error });
    }
  },
  async [EXERCISE_LOGS_REQUEST]({ commit, rootGetters }: any, payload: any) {
    try {
      commit(EXERCISE_LOGS, undefined);

      const authInfo = await getAuthInfo(rootGetters);
      const payloadWithLang = { ...payload, lang: "ja" };
      const response = await api.learningHistory.exerciseLogs({
        params: payloadWithLang,
        authInfo
      });

      commit(EXERCISE_LOGS, response.data);
    } catch (error) {
      console.log({ error });
    }
  },
  async [LEARNING_STATS_REQUEST]({ commit, rootGetters }: any, payload: any) {
    try {
      commit(LEARNING_STATS, {
        [payload.exerciseType]: undefined
      });

      const authInfo = await getAuthInfo(rootGetters);
      const payloadWithLang = { payload, lang: "ja" };

      const statsRequest = await api.learningHistory.learningStats({
        exerciseType: payload.exerciseType,
        params: payloadWithLang,
        authInfo
      });

      const data = {
        [payload.exerciseType]: statsRequest.data
      };

      commit(LEARNING_STATS, data);
    } catch (error) {
      console.log({ error });
    }
  },
  async [PERFORMANCE_SUMMARY_REQUEST]({ commit, rootGetters }: any, payload: any) {
    try {
      commit(PERFORMANCE_SUMMARY, {
        averageRetry: undefined,
        exerciseCefrDistribution: undefined,
        reactionTime: undefined,
        wordsPerMinute: undefined
      });

      const authInfo = await getAuthInfo(rootGetters);
      const response = await api.learningHistory.performanceSummary({ params: payload, authInfo });

      commit(PERFORMANCE_SUMMARY, response.data);
    } catch (error) {
      console.log({ error });
    }
  },
  async [SEND_FEEDBACK]({ rootGetters }: any, payload: any) {
    try {
      const authInfo = await getAuthInfo(rootGetters);
      const response = await api.learningHistory.userFeedback({ params: payload, authInfo });
    } catch (error) {
      console.log({ error });
    }
  },
  async [RECENT_EXERCISES_REQUEST]({ commit, rootGetters }: any, payload: any) {
    try {
      commit(LOADING, true);
      commit(RECENT_EXERCISES, undefined);

      const authInfo = await getAuthInfo(rootGetters);
      const payloadWithLang = { ...payload, lang: "ja" };
      const response = await api.learningHistory.recentExercises({
        params: payloadWithLang,
        authInfo
      });

      commit(RECENT_EXERCISES, response.data);
    } catch (error) {
      console.log({ error });
    } finally {
      commit(LOADING, false);
    }
  }
};

export { historyActions };
